export default function Version() {
    return (
        <>
            v1.14.5
        </>
    )
}